<div class="flex items-center justify-center w-full banner bg-center bg-cover" style="background-image: url({{this.headerImage}});">
  <div class="flex max:w-2/3 flex-col p-4">
    <h1 [style.color]="headerTextColor" class=" text-center md:text-6xl font-bold text-4xl max-sm:text-left">
      {{headerTitle}}
    </h1>
  </div>
</div>

<div class="flex-wrap justify-center mb-12 px-4 flex-shrink-0 items-center w-11/12 mx-auto p-8">
  <div class="flex p-3 w-full">
    <h1 class="text-4xl font-extrabold text-primary-600 w-full text-center">
      How can we help you?
    </h1>
  </div>

  <div class="border-t-2 border-gray-200 my-4"> </div>

  <div class="w-full flex flex-row justify-center items-center mt-4">
    <div class="flex flex-row border border-primary-100 rounded-lg">
      <div *ngFor="let ct of categoryTypes" class="flex-col md:mx-4 hover:cursor-pointer">
        <div [ngClass]="selectedCategory == ct.title ? 'active' : 'notActive'"  (click)=toggleCategory(ct.title) class="text-sm md:text-base">
          <div class="text-center">
            {{ct.title}}
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="flex flex-row max-sm:grid max-sm:grid-cols-2 justify-center items-center">    
  <div *ngFor="let item of bodyContentFiltered" class="flex justify-center items-center">
      <fuse-card (click)="supportById(item.id)"
        class="sm:flex-col m-4 md:m-8 bg-white justify-center items-center rounded-3xl border border-primary-100 hover:cursor-pointer hover:bg-[#edeeff] w-36 h-36 md:w-50 md:h-50 max-sm:h-32 max-sm:w-32"
          [ngClass]="selectedSubCategory == item.id ? 'subActive' : 'subActiveNot'" >
        <div class="flex flex-col">
          <div class="flex w-full justify-center">
            <img [src]="item.icon?.url" alt="category icon" class="h-10 w-10" loading="lazy">
          </div>
          <div class="flex font-bold w-full mt-4 text-base md:text-xl justify-center items-center">
            {{item.topic}}
          </div>
        </div>
      </fuse-card>
    </div>
  </div>


  <div class="flex-wrap justify-center mb-12 px-4 flex-shrink-0 items-center w-full md:w-11/12 mx-auto p-8" *ngIf="faqsContent?.faqs">
    <div class="flex p-3 w-full" #faqs>
      <h1 class="text-xl md:text-4xl font-extrabold text-primary-600 w-full text-center">
          {{faqsContent.topic}}
      </h1>
    </div>
    <div class="border-t-2 border-gray-200 my-4"></div>
    <mat-accordion class="w-full">
        <mat-expansion-panel (opened)="panelOpened = true" (closed)="panelOpened = false" *ngFor="let f of faqsContent.faqs" hideToggle #panel class="hover:bg-gray-100 w-full">
            <mat-expansion-panel-header  class="w-full h-fit m-0">
                <mat-panel-title class="w-full h-fit max-sm:py-3 max-sm:px-1 lg:p-4 text-xl flex flex-row justify-between items-center">
                    <div class="text-left w-full max-sm:text-sm">
                        {{ f.Title }}
                    </div>
                    <div class="pl-6 text-right">
                        <mat-icon color="primary" *ngIf="panel.expanded"
                            svgIcon="heroicons_solid:minus-circle"></mat-icon>
                        <mat-icon color="primary" *ngIf="!panel.expanded"
                            svgIcon="heroicons_solid:plus-circle"></mat-icon>
                    </div>
                </mat-panel-title>
  
            </mat-expansion-panel-header>
            <div 
              *ngIf="panelOpened"
              id="faq-content"
              class="max-sm:text-sm text-xl w-full text-grey_purple-600 font-medium mt-4 lg:px-4 max-sm:pr-4 text-left faq-content" 
              [innerHTML]="f.Description | innerHTMLPipe">
            </div>
        </mat-expansion-panel>
    </mat-accordion>
  </div>

</div>



<div class="w-full bg-[#E9E9EB] p-18 items-center text-center">
  <!-- <h1 class="text-4xl font-semibold text-black p-3 text-center ">
    Contact us
  </h1> -->
  <h2 class="text-xl text-grey_purple-600 mb-8">If you still need any help, please get in touch with us</h2>

  <button class="default-button font-semibold py-2 px-5 mr-2" routerLink="/contact-us">
    <span class="ml-2">Contact us</span>
  </button>
  <!-- <button class="yellow-button bg-accent-500 text-brown-600 font-bold py-5 px-6">
    Call me back
  </button> -->
</div>